/*
 * Adds browser specific CSS classes to the HTML tag
 */
const bowser = require('bowser');

module.exports = (function() {
  const rootEl = document.getElementsByTagName('html')[0];
  let classes = [];

  classes.push(convertToCSSClassName(bowser.name));
  classes.push(convertToCSSClassName(bowser.name + '-' + bowser.version));
  classes.push(convertToCSSClassName(bowser.osname));
  classes.push(convertToCSSClassName(bowser.osname + '-' + bowser.osversion));
  rootEl.className += ' ' + classes.join(' ');

  function convertToCSSClassName(value) {
    return value
            .toLowerCase()
            .replace(/[\.\s]/g, '_')
  }
})();





// WEBPACK FOOTER //
// ./resources/assets/js/detectBrowser.js